var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMidtargetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.127,
    cy: 14.258,
    r: 1.602,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m20.4 7.056-4.53 4.53a2 2 0 0 1-1.022.547l-2.09.418.419-2.09a2 2 0 0 1 .546-1.022l4.53-4.53M20.4 7.057l1.128-1.129a1 1 0 0 0 0-1.414l-.732-.732a1 1 0 0 0-1.414 0L18.253 4.91M20.4 7.056 18.253 4.91"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M19.923 13.48c0 1.66-.452 4.148-1.43 5.528-.979 1.38-2.275 2.515-3.902 3.15-1.627.635-3.572.966-5.299.642-1.727-.323-3.398-1.41-4.643-2.582a8.251 8.251 0 0 1-2.437-4.296c-.343-1.627-.193-3.866.48-5.4.674-1.532 2.08-3.127 3.544-4.049 1.464-.922 3.636-1.221 5.397-1.221"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M16.814 13.893a5.25 5.25 0 0 1-.916 2.958 5.411 5.411 0 0 1-2.438 1.961 5.537 5.537 0 0 1-3.14.303 5.468 5.468 0 0 1-2.781-1.457 5.293 5.293 0 0 1-1.487-2.727 5.226 5.226 0 0 1 .309-3.076 5.35 5.35 0 0 1 2-2.39 5.512 5.512 0 0 1 3.02-.897"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z",
    transform: "translate(.135 .469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidtargetIcon);
export default __webpack_public_path__ + "static/media/midtargetIcon.3a994c4d96b2947af48e1596999edad2.svg";
export { ForwardRef as ReactComponent };